import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Box, BoxPriceLog } from 'src/app/models/box/box.model';

@Injectable({
  providedIn: 'root'
})
export class BoxesService {
  private baseUrl = 'https://www.aspiresecurities.com/webdataapi';

  constructor(private http: HttpClient) { }

  getBoxes(): Observable<Box[]> {
    return this.http.get<Box[]>(`${this.baseUrl}/api/Boxes`);
  }

  getBoxLogs(boxId: number): Observable<BoxPriceLog[]> {
    return this.http.get<BoxPriceLog[]>(`${this.baseUrl}/api/Boxes/${boxId}/logs`);
  }
}
